export default () => {
  const hotelElements = document.querySelectorAll('[component="hotel"]');

  hotelElements.forEach((hotel) => {
    const infoBoxHotelLeft = hotel.querySelector('[child="info-box-hotel-left"]');
    const infoBoxHotelRight = hotel.querySelector('[child="info-box-hotel-right"]');
    const mapInfoBoxLeft = hotel.querySelector('[child="map-info-box-left"]');

    if (mapInfoBoxLeft) {
      const { backgroundColor, textColor } = mapInfoBoxLeft.dataset;

      if (backgroundColor) {
        mapInfoBoxLeft.style.backgroundColor = backgroundColor;
      }
      if (textColor) {
        mapInfoBoxLeft.style.color = textColor;
      }
    }

    if (infoBoxHotelLeft) {
      const { backgroundColor, textColor } = infoBoxHotelLeft.dataset;

      if (backgroundColor) {
        infoBoxHotelLeft.style.backgroundColor = backgroundColor;
      }
      if (textColor) {
        infoBoxHotelLeft.style.color = textColor;
      }
    }

    if (infoBoxHotelRight) {
      const { backgroundColor, textColor } = infoBoxHotelRight.dataset;

      if (backgroundColor) {
        infoBoxHotelRight.style.backgroundColor = backgroundColor;
      }
      if (textColor) {
        infoBoxHotelRight.style.color = textColor;
      }
    }
  });
};
